import { useLocation } from 'react-router-dom'
import { SearchParameters } from '../../constants'

type ParsedSearchParameters = Partial<Record<SearchParameters, string | string[]>>

const upperCaseParams = [SearchParameters.APPOINTMENT_TYPE, SearchParameters.DELIVERY_MODEL, SearchParameters.JOURNEY]

const useSearchParameters = (): ParsedSearchParameters => {
  const { search } = useLocation()

  const params = new URLSearchParams(search)

  const paramsMap: ParsedSearchParameters = {}

  for (const pair of params.entries()) {
    if (pair[1] === '') continue
    // @ts-expect-error URLSearchParams keys are string; we assign into SearchParameters record
    paramsMap[pair[0]] = pair[1]
  }

  upperCaseParams.forEach((param) => {
    const value = paramsMap[param]

    if (typeof value === 'string') {
      paramsMap[param] = value.trim().toUpperCase()
    }
  })

  return paramsMap
}

export { SearchParameters, useSearchParameters }
